import React from 'react';
import { SelectField, FormField } from '../styleguide';

export default ({
  required,
  name,
  disabled,
  formData: value,
  schema: { title: label, options, validationMessages, placeholder },
  onChange,
  rawErrors,
}) => {
  const handleChange = ({ target: { value } }) => onChange(value === '' ? undefined : value);
  const errorId = Array.isArray(rawErrors) && rawErrors[0];
  const errorMessage = validationMessages ? validationMessages[errorId] : errorId;

  return (
    <FormField error={errorMessage} text={label} required={required} value={value}>
      <SelectField
        disabled={disabled}
        name={name}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        value={value}
      />
    </FormField>
  );
};
